"use client";

import { c as _c } from "react/compiler-runtime";
import { useApmRouteTracking } from "@nais/apm/react";
import { usePathname } from "next/navigation";
import { normalizeBrowserPath } from "./browser";
export function ApmRouteTracker() {
  const $ = _c(2);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname ? normalizeBrowserPath(pathname) : null;
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useApmRouteTracking(t0);
  return null;
}